import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchManagedSurveys: DocumentNode = gql`
  query FetchManagedSurveys($storyId: String!, $version: String!, $relations: String, $params: String) {
    fetchManagedStoryContent(storyId: $storyId, version: $version, relations: $relations, params: $params) {
      ... on ManagedStoryContent {
        cv
        story {
          content {
            actions
            component
            uid
            surveys
          }
        }
        rels
      }
      ... on ManagedStoryContentNotFound {
        json
        message
        code
      }
    }
  }
`

export default fetchManagedSurveys
